module.exports = __webpack_public_path__ + "static/media/en-cancel-package_4.943abbad.png";